<template>
  <b-row>
    <!-- CERTIFICAT -->
    <b-col sm="12" class="form-group" >
      <label v-if="!readonly">
        {{ $t('common.security.import_cert') }}
      </label>
    </b-col>
    <b-col sm="6" class="form-group" v-if="!readonly">
      <form-write-group-label-input v-model="name" isMandatory 
      :inputLabel="$t('common.security.cert_name')">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else>
      <form-read-group-label-input 
      :inputLabel="$t('common.security.cert_name')"
      :inputValue="name">
      </form-read-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-if="!readonly"> 
      <form-write-group-label-input v-model="certificate" isMandatory 
        :inputLabel="$t('common.security.certificate')">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else>
      <form-read-group-label-input 
      :inputLabel="$t('common.security.certificate')"
      :inputValue="certificate">
      </form-read-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-if="!readonly">
      <label>
        {{ $t('common.type_label') }}<span class="color-red"> * </span>
      </label>
      <select class="form-control" v-model="type">
        <option value="0">Veuillez sélectionner un type...</option>
        <option value="CA">{{ $t('common.security.ca') }}</option>
        <option value="SMIME">{{ $t('common.security.smime') }}</option>
        <option value="SSL">{{ $t('common.security.ssl') }}</option>
      </select>
    </b-col>
    <b-col sm="6" class="form-group" v-else>
      <form-read-group-label-input 
      :inputLabel="$t('common.type_label')"
      :inputValue="type">
      </form-read-group-label-input>
    </b-col>
    <b-col sm="3" class="form-group" v-if="!readonly"> 
      <form-write-group-label-input v-model="startDate" :disabled="readonly"
        :inputLabel="$t('common.security.valid_date')"
        inputType="datetime">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="3" class="form-group" v-else>
      <form-read-group-label-input
        :inputLabel="$t('common.security.valid_date')"
        :inputValue="startDate">
      </form-read-group-label-input>
    </b-col>
    <b-col sm="3" class="form-group" v-if="!readonly">
      <form-write-group-label-input v-model="endDate" :disabled="readonly"
        :inputLabel="$t('common.security.unvalid_date')"
        inputType="datetime">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="3" class="form-group" v-else>
      <form-read-group-label-input
        :inputLabel="$t('common.security.unvalid_date')"
        :inputValue="endDate">
      </form-read-group-label-input>
    </b-col>
    <b-col cols="3" class="form-group" v-if="this.formType !== 'add' && !readonly">
      <b-checkbox v-model="checkboxChangePass">Changer le mot de passe </b-checkbox>
    </b-col>
    <b-col cols="3" class="form-group" v-if="this.formType !== 'add' && !readonly">
      <b-checkbox v-model="checkboxShowPass">Afficher les mots de passe</b-checkbox>
    </b-col>
    <b-col v-if="this.formType !== 'add' && !readonly" cols="6"></b-col>
    <b-col sm="6" class="form-group" v-if="this.formType === 'add'">
      <form-write-group-label-input v-model="password" isMandatory
        :inputLabel="$t('common.pwd')"
        :inputType="'password'">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else-if="!readonly && checkboxChangePass === true">
      <form-write-group-label-input v-model="password" isMandatory
        :inputLabel="$t('common.pwd')"
        :inputType="passwordFieldType">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-if="this.formType === 'add'">
      <form-write-group-label-input v-model="passwordVerif" isMandatory 
        :inputLabel="$t('common.security.verif_password')"
        :inputType="'password'">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else-if="!readonly && checkboxChangePass === true">
      <form-write-group-label-input v-model="passwordVerif" isMandatory 
        :inputLabel="$t('common.security.verif_password')"
        :inputType="passwordFieldType">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-if="!readonly">
      <form-write-group-label-input v-model="cn" isMandatory 
        :inputLabel="$t('common.security.cn')">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else>
      <form-read-group-label-input 
      :inputLabel="$t('common.security.cn')"
      :inputValue="cn">
      </form-read-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-if="!readonly">
      <label>
        {{ $t('common.security.pod') }}<span class="color-red"> * </span>
      </label>
      <select class="form-control" v-model="idPod">
        <option v-for="pod in podList" :key="pod.id" :value="pod.name">
          {{ pod.name }}
        </option>
      </select>
    </b-col>
    <b-col sm="6" class="form-group" v-else>
      <form-read-group-label-input 
        :inputLabel="$t('common.security.pod')"
        :inputValue="idPod">
      </form-read-group-label-input>
    </b-col>
  </b-row>
</template>
<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import { formatDateTime } from '@/helpers/format'
import moment from 'moment'
export default {
  name: 'CertificateFormGlobal',
  components: {
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-accordion': FormAccordion
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    placementCertificate: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    name:{
      get () {
        return this.inputValue.name
      },
      set (val) {
        this.inputValue = {
          name: val,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    certificate:{
      get () {
        return this.inputValue.certificate
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: val,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    type:{
      get () {
        return this.inputValue.type
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: val,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    startDate:{
      get () {
        return moment(this.inputValue.startDate).format('YYYY-MM-DD HH:mm')
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: formatDateTime(val),
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    endDate:{
      get () {
        return moment(this.inputValue.endDate).format('YYYY-MM-DD HH:mm')
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: formatDateTime(val),
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    password:{
      get () {
        return this.inputValue.password
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: val,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    passwordVerif:{
      get () {
        return this.inputValue.passwordVerif
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: val,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    cn:{
      get () {
        return this.inputValue.cn
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: val,
          idPod: this.inputValue.idPod
        }
      }
    },
    idPod:{
      get () {
        return this.inputValue.idPod
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: val
        }
      }
    },
    pageTitle () {
      return this.$i18n.t('common.security.cert_info') + (this.placementCertificate + 1 > 0 ? (' ' + (this.placementCertificate)) : '')
    },
  },
  data () { 
    return {
      checkboxChangePass: false,
      checkboxShowPass: false,
      formType: 'add',
      passwordFieldType : 'password',
      podList: []     
    }
  },
  created () {
    this.formType = this.mode
    if (this.formType === 'create') {
      this.formType = 'add'
    }
    if (this.formType === 'add') {  
      this.inputValue.startDate = moment().format('YYYY-MM-DDTHH:mm')
      this.inputValue.endDate = moment().format('YYYY-MM-DDTHH:mm')
    }
    if (this.formType === 'view') {
      this.inputValue.passwordVerif = this.value.password
    }
    this.getPods()
  },
  methods: {
    getPods() {
      let that = this 
    
      this.$engine.routing.pod.fetch()
      .then(resp => {
        let podsObject = {}
        podsObject = resp.data.Pods
        that.updatePods(podsObject)
        this.$f7.pullToRefreshDone()
      })
    },
    toggleVisibility(){
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
      } else {
        this.passwordFieldType = 'password'
      }
    },
    updatePods(podsObject) {
      this.podList = podsObject
    }
  },
  watch: {
    checkboxChangePass () {
      if(this.checkboxChangePass === true) {
        this.inputValue.passwordVerif = ''
      } else {
        this.inputValue.passwordVerif = this.value.password
      }
    },
    checkboxShowPass(){
      this.toggleVisibility()
    }
  }
}
</script>